import React from "react";
import Navbar from "../components/HomePage/Navbar";
import Footer from "../components/HomePage/Footer";

const Layout = ({children}) => {
  return (
    <div className="w-full min-h-screen overflow-y-auto h-[100vh] main_bg">
      <Navbar />
      <div className="">{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
